import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogTitle,
  Modal,
} from "@mui/material";
import { Fragment, useMemo, useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import {
  gql,
  useAuth,
  useMutation,
  useQuery,
} from "@shared/utils";

const GET_ME = gql`
  query GetMe {
    me {
      _id
      acceptedTOS
    }
  }
`;

const ACCEPT_TOS = gql`
  mutation AcceptTos {
    acceptTos {
      _id
      acceptedTOS
    }
  }
`;

export const LicenseAgreement = () => {
  const { data } = useQuery<{
    me?: {
      _id: string;
      acceptedTOS?: boolean;
    };
  }>(GET_ME);
  const [acceptTos] = useMutation(ACCEPT_TOS);
  const acceptedTos = useMemo(() => {
    if (!data?.me) {
      return false;
    }
    return !(data.me.acceptedTOS || false);
  }, [JSON.stringify(data)]);
  const [numPages, setNumPages] = useState<null | number>(null);
  const pages = useMemo(() => {
    if (!numPages) return [];

    return Array(numPages)
      .fill(0)
      .map((v, i) => ++i);
  }, [numPages]);
  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }
  return (
    <Dialog open={acceptedTos} maxWidth="xl">
      <Box
        sx={{
          overflowY: "scroll",
          overflowX: "hidden",
          "&:hover::-webkit-scrollbar": {
            display: "block",
          },
          "&::-webkit-scrollbar": {
            display: "none",
            width: "0.512rem",
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#8d8e90",
            height: "8px",
            borderRadius: "8px",
          },
        }}
      >
        <Document
          onLoadSuccess={onDocumentLoadSuccess}
          file="https://s3.us-central-1.wasabisys.com/simpallo-files/shared/LicenseAgreement.pdf"
        >
          {pages.map((pageNumber) => (
            <Fragment key={pageNumber}>
              <Page pageNumber={pageNumber} />
            </Fragment>
          ))}
        </Document>
        <Box sx={{ maxWidth: "400px", margin: "auto" }}>
          Although Simpallo is pre-loaded with Core Products and/or Product
          Configurations they are to be treated as examples of how the software
          operates. These Core Products and associated Configurations are
          subject to containing errors. Users are responsible for verifying all
          calculations and material list outputs prior to bidding any project.
          Turbeville Tech, LLC &ldquo;Simpallo&ldquo; is not responsible for
          accuracy of any material list, pricing, drawing scale, user entries,
          or any other miscalculations.
        </Box>
      </Box>
      <DialogActions>
        <Button
          onClick={() => {
            acceptTos();
          }}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};
